/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ movement: NonNullable<unknown> }} Prescription_Exhausted_EquipmentInputs */

const en_us2_prescription_exhausted_equipment = /** @type {(inputs: Prescription_Exhausted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`That is every ${i?.movement} exercise your equipment allows. Add equipment to see more.`)
};

const pt_br2_prescription_exhausted_equipment = /** @type {(inputs: Prescription_Exhausted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esses são todos os exercícios de ${i?.movement} que seu equipamento permite. Adicione equipamento para ver mais.`)
};

const es_419_prescription_exhausted_equipment = /** @type {(inputs: Prescription_Exhausted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esos son todos los ejercicios de ${i?.movement} que tu equipo permite. Agrega equipo para ver más.`)
};

const pt_pt2_prescription_exhausted_equipment = /** @type {(inputs: Prescription_Exhausted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estes são todos os exercícios de ${i?.movement} que o teu equipamento permite. Adiciona equipamento para ver mais.`)
};

const fr_fr2_prescription_exhausted_equipment = /** @type {(inputs: Prescription_Exhausted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ce sont tous les exercices de ${i?.movement} que ton matériel permet. Ajoute du matériel pour en voir plus.`)
};

const de_de2_prescription_exhausted_equipment = /** @type {(inputs: Prescription_Exhausted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das sind alle Übungen für „${i?.movement}“, die deine Ausrüstung erlaubt. Füge Ausrüstung hinzu, um mehr zu sehen.`)
};

const it_it2_prescription_exhausted_equipment = /** @type {(inputs: Prescription_Exhausted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questi sono tutti gli esercizi di ${i?.movement} che la tua attrezzatura consente. Aggiungi attrezzatura per vederne altri.`)
};

/**
* | output |
* | --- |
* | "That is every {movement} exercise your equipment allows. Add equipment to see more." |
*
* @param {Prescription_Exhausted_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_exhausted_equipment = /** @type {((inputs: Prescription_Exhausted_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Exhausted_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_exhausted_equipment(inputs)
	if (locale === "es-419") return es_419_prescription_exhausted_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_exhausted_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_exhausted_equipment(inputs)
	if (locale === "de-DE") return de_de2_prescription_exhausted_equipment(inputs)
	if (locale === "it-IT") return it_it2_prescription_exhausted_equipment(inputs)
	return en_us2_prescription_exhausted_equipment(inputs)
});
export { prescription_exhausted_equipment as "prescription.exhausted.equipment" }